function initAnimation() {
  let itemsPositions = [
    {
      from: 200,
      to: -200,
    },
    {
      
      from: 600,
      to: -350,
    },
    {
      
      from: 300,
      to: -300,
    },
    {
      
      from: 400,
      to: -350,
    },
    {
      
      from: 700,
      to: -450,
    },
    {
      from: 800,
      to: -800,
      scale: 1
    },


    
    {
      from: 200,
      to: -200,
    },
    {
      
      from: 300,
      to: -300,
    },
    {
      
      from: 400,
      to: -350,
    },
    {
      
      from: 700,
      to: -450,
    },
    {
      
      from: 200,
      to: -200,
    },
  ];

  let items = document.querySelectorAll('.puzzle__items div');
  items.forEach((item, index) => {
    let from = itemsPositions[index]?.from || 0;
    let to = itemsPositions[index]?.to || 0;
    let scale = itemsPositions[index]?.scale || 1;
    if (isMobile) {
      from = from / 1.5;
    } else if (isTablet) {
      // from = from;
      to = to / 3;
    }
    from = from / 16 + 'rem';
    to = to / 16 + 'rem';
    gsap.fromTo(item, {
      y: from,
      scale: scale,
    }, {
      y: to,
      scale: scale,
      ease: 'none',
      scrollTrigger: {
        trigger: '.section--puzzle',
        start: isMobile ? 'top 70%' : 'top bottom',
        end: '+=1500',
        scrub: true,
      },
    });
  });

  gsap.fromTo('.puzzle__bg', {
    y: 0,
  }, {
    y: '-160px',
    ease: 'none',
    scrollTrigger: {
      trigger: '.section--puzzle',
      start: 'top bottom',
      end: '+=1500',
      scrub: true,
    },
  });

  gsap.fromTo('.puzzle__img', {
    y: isTablet ? 0 : 300,
  }, {
    y: '-400px',
    ease: 'none',
    scrollTrigger: {
      trigger: '.section--puzzle',
      start: 'top bottom',
      end: '+=1500',
      scrub: true,
    },
  });

  gsap.fromTo('.section--puzzle .title', {
    y: 0,
  }, {
    y: -100,
    ease: 'none',
    scrollTrigger: {
      trigger: '.section--puzzle',
      start: 'top bottom',
      end: '+=1500',
      scrub: true,
    },
  });


  gsap.fromTo('.section--puzzle .text', {
    y: 0,
  }, {
    y: -100,
    ease: 'none',
    scrollTrigger: {
      trigger: '.section--puzzle',
      start: 'top bottom',
      end: '+=1500',
      scrub: true,
    },
  });

  gsap.fromTo('.video-product', {
    scale: 1.1,
  }, {
    scale: 1,
    ease: 'none',
    scrollTrigger: {
      trigger: '.section--video-product',
      start: 'top bottom',
      end: '+=1000',
      scrub: true,
    },
  });


  let uniqueElements = document.querySelectorAll('.unique__puzzle');
  let uniquePositions = [
    {
      y: -200,
      x: -800,
      z: -50,
      scale: 2,
      speed: 1000,
    },
    {
      
      y: -200,
      x: 200,
      z: -50,
      scale: 1.2,
      speed: 1000,
    },

    {
      y: -600,
      x: 900,
      z: -50,
      scale: 1.3,
      speed: 1200,
    },
    {
      y: 400,
      x: -1500,
      z: -50,
      scale: 1.5,
      speed: 1550,
    },
    {
      y: -400,
      x: 100,
      z: -50,
      scale: 1.2,
      speed: 800
    },
    {
      y: -400,
      x: -500,
      z: -50,
      scale: 2,
      speed: 700
    },
    {
      y: -200,
      x: -500,
      z: -50,
      scale: 1.2,
      speed: 900
    },
    {
      y: -400,
      x: 100,
      z: -50,
      scale: 1.5,
      speed: 900
    },
    {
      y: -200,
      x: 500,
      z: -50,
      scale: 2.5,
      speed: 900
    },
    {
      y: -200,
      x: 500,
      z: -50,
      scale: 2.5,
      speed: 1400
    },
    {
      y: 400,
      x: 700,
      z: -50,
      scale: 2,
      speed: 1500,
      delay: '100%'
    },
    {
      y: 300,
      x: 400,
      z: -50,
      scale: 2,
      speed: 700,
    },
    {
      y: 400,
      x: 100,
      z: -50,
      scale: 2,
      speed: 1400,
      delay: '100%'
    },
    {
      y: 400,
      x: 700,
      z: -50,
      scale: 2,
      speed: 1200,
      delay: '100%'
    },
    {
      y: -800,
      x: 1100,
      z: -50,
      scale: 1.3,
      speed: 1000,
      delay: '100%'
    },
    {
      y: 400,
      x: 1400,
      z: -50,
      scale: 2.3,
      speed: 1500,
      delay: '100%'
    },
    {
      y: -400,
      x: 1500,
      z: -50,
      scale: 2.2,
      speed: 1400,
      delay: '100%'
    },
    {
      y: -600,
      x: 1200,
      z: -50,
      scale: 2,
      speed: 1200,
      delay: '100%'
    },
  ];
  

  uniqueElements.forEach((element, index) => {
    let x = uniquePositions[index]?.x || 0;
    let y = uniquePositions[index]?.y || 0;
    let z = uniquePositions[index]?.z || 0;
    let scale = uniquePositions[index]?.scale || 1;
    let speed = uniquePositions[index]?.speed || 1500;
    let delay = uniquePositions[index]?.delay || 'bottom';
    if (isMobile) {
      speed = speed / 2;
      y = y / 4;
      x = x / 2;
      delay = 0;

      if (index === 12) {
        y = 50;
        x = 300;
      } else if (index === 3) {
        y = 100;
        x = -600;
        speed = 750;
      } else if (index === 4) {
        x = 300;
        y = -200;
        speed = 500;
      }
    } else if (isTablet) {
      speed = speed / 2;
      y = y / 2;
    }
    gsap.fromTo(element, {
      y: y,
      x: x,
      z: z,
      scale: scale,
    }, {
      y: 0,
      z: 0,
      x: 0,
      scale: 1,
      ease: 'none',
      delay: delay,
      scrollTrigger: {
        trigger: '.unique__puzzles',
        start: isMobile ? 'top 90%' : 'top bottom',
        end: '+=' + speed,
        scrub: true,
      },
    });
  });
  ScrollTrigger.create({
    trigger: '.unique__img',
    start: 'bottom bottom',
    end: '+=600',
    pin: isMobile ? false : true,
    onToggle: (self) => {
      if (document.querySelector('.unique__img')) {
        document.querySelector('.unique__img').classList.toggle('unique__img--active', self.isActive);
      }
    }
  });

  document.querySelectorAll('.octopus__puzzle').forEach((octopus, index) => {
    let direction = index % 2 === 0 ? 1 : -1;
    let translate = index % 2 === 0 ? 100 : 50;
    if (isMobile) {
      translate = translate * 1.5;
    }
    gsap.fromTo(octopus, {
      y: 0,
    }, {
      y: translate * direction,
      ease: 'none',
      scrollTrigger: {
        trigger: '.octopus__puzzles',
        start: 'top bottom',
        end: '+=1500',
        scrub: true,
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initAnimation);